export const FORM_DATA_LOADING = 'FORM_DATA_LOADING'
export const REGISTRATION_LOADING = 'REGISTRATION_LOADING'
export const RESET_REGISTRATION = 'RESET_REGISTRATION'
export const GET_FORM_DATA = 'GET_FORM_DATA'
export const SUBMIT_REGISTRATION = 'SUBMIT_REGISTRATION'
export const UPDATE_REGISTRATION = 'UPDATE_REGISTRATION'
export const UPDATE_OTHER_REGISTRATION = 'UPDATE_OTHER_REGISTRATION'
export const GET_REGISTRATION = 'GET_REGISTRATION'
export const GET_OTHER_REGISTRATION = 'GET_OTHER_REGISTRATION'
export const DOCUMENTS_LOADING = 'DOCUMENTS_LOADING'
export const GET_DOCUMENTS = 'GET_DOCUMENTS'
export const ADD_DOCUMENT = 'ADD_DOCUMENT'
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT'
export const GET_COMPETITION_DAYS = 'GET_COMPETITION_DAYS'
export const UPDATE_COMPETITION_DAY = 'UPDATE_COMPETITION_DAY'
export const GET_COMPETITOR_STATUSES = 'GET_COMPETITOR_STATUSES'
export const UPDATE_COMPETITOR_STATUS = 'UPDATE_COMPETITOR_STATUS'
export const RESET_COMPETITOR_STATUSES = 'RESET_COMPETITOR_STATUSES'
export const LOADING_COMPETITOR_STATUSES = 'LOADING_COMPETITOR_STATUSES'
export const ADD_IGC = 'ADD_IGC'
export const ADD_IGC_SUCCESS = 'ADD_IGC_SUCCESS'
export const ADD_IGC_ERROR = 'ADD_IGC_ERROR'
export const GET_IGC_FORM_DATA = 'GET_IGC_FORM_DATA'
export const GET_IGC_FILES = 'GET_IGC_FILES'
export const RESET_IGC_FILES = 'RESET_IGC_FILES'
export const UPDATE_IGC_FILE = 'UPDATE_IGC_FILE'
export const ADD_TRACKING = 'ADD_TRACKING'
export const GET_TRACKINGS = 'GET_TRACKINGS'
